module.exports = __webpack_public_path__ + "media/images/haircut/main_image1@2x-a6a190706d542973dff6dc56cc4f2bea.jpg";